module.exports = require("./fr-DJ.d.ts");